import { create } from 'zustand';

export const useModalStore = create((set) => ({
  isCortexModalOpen: true,
  setIsCortexModalOpen: (status) => set({ isCortexModalOpen: status }),
}));
